module.exports = __webpack_public_path__ + "img/pheboen.8b5de212.png";